import { render, staticRenderFns } from "./DriverForm.vue?vue&type=template&id=31f562c1&scoped=true&"
import script from "./DriverForm.vue?vue&type=script&lang=js&"
export * from "./DriverForm.vue?vue&type=script&lang=js&"
import style0 from "./DriverForm.vue?vue&type=style&index=0&id=31f562c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f562c1",
  null
  
)

export default component.exports